import { xBaseTheme } from "@eisinc/XDL/types";

export default {} as xBaseTheme;
